import { Injectable } from '@angular/core';
import posthog from 'posthog-js';

@Injectable({
  providedIn: 'root'
})
export class PostHogService {
    private nextContentAccessData: any = null;
  
    /**
     * Used to set the data for the next content access event.
     * This data will be merged with the properties of the event when it is tracked.
     * 
     * This is useful for tracking the source of the content access, such as 'menu', 'search', etc.
     * 
     * @param data - The data to be set for the next content access event.
     */
    setNextContentAccess(data: any) {
      console.log('PostHogService: Setting next content access data:', JSON.stringify(data));
      this.nextContentAccessData = data;
    }
    
    trackContentAccessed(contentId: string, additionalProps = {}) {
      const props = {
        ...this.nextContentAccessData,
        ...additionalProps,
        content_id: contentId
      };
      
      console.log('PostHogService: Tracking content accessed:', JSON.stringify( props));
      posthog.capture('content_accessed', props);
      
      // Clear after use
      this.nextContentAccessData = null;
    }

    trackSearchPerformed(searchTerm: string, additionalProps = {}) {
      const props = {
        ...this.nextContentAccessData,
        ...additionalProps,
        search_term: searchTerm
      };
      
      console.log('PostHogService: Tracking search performed:', JSON.stringify( props));
      posthog.capture('search_performed', props);
      
      // Clear after use
      this.nextContentAccessData = null;
    }

    trackCategoryNavigation(item_id: string, additionalProps = {}) {
      const props = {
        ...this.nextContentAccessData,
        ...additionalProps,
        item_id: item_id
      };
      
      console.log('PostHogService: Tracking category browsed:', JSON.stringify( props));
      posthog.capture('category_browsed', props);
      
      // Clear after use
      this.nextContentAccessData = null;
    } 

    trackApplicationAccess(application: string, additionalProps = {}) {
      const props = {
        ...this.nextContentAccessData,
        ...additionalProps,
        application: application
      };
      
      console.log('PostHogService: Tracking application accessed:', JSON.stringify( props));
      posthog.capture('application_accessed', props);
      
      // Clear after use
      this.nextContentAccessData = null;
    } 

    trackTabClick(tabName: string, additionalProps = {}) {
      const props = {
        ...this.nextContentAccessData,
        ...additionalProps,
        tab_name: tabName
      };
      
      console.log('PostHogService: Tracking tab clicked:', JSON.stringify( props));
      posthog.capture('tab_clicked', props);

    }
    
}